/**
 * To return data on basis of key
 * @param {object} state
 * @param {string} key
 */
export const getBusinessData = (state, key) => {
  const data = state.officer ? state.officer.toJS() : {};
  return data[key] || [];
};

export const getOfficerDataLength = (state, key) => {
  const data = state.officer ? state.officer.toJS() : {};
  return data[key] ? data[key].length : 0;
};
